<template>
  <div>
    <div>
      <div class="form-actions flex justify-between">
        <div class="float-right flex">
          <vx-tooltip text="View all MIS" position="top">
            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-external-link" @click="viewAllMIS()"></vs-button>
          </vx-tooltip>
        </div>
      </div>

      <div class="dashboard-scrollable-area">
        <div id="grid-loader" class="vx-card vs-con-loading__container">
          <ag-grid-vue
            id="autoHeightGrid"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 mb-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :components="components"
            :rowData="tableData"
            rowSelection="multiple"
            :enableRangeSelection="true"
            :suppressCopyRowsToClipboard="true"
            :suppressDragLeaveHidesColumns="true"
            :animateRows="false"
            :floatingFilter="true"
            :pagination="false"
            :suppressRowClickSelection="true"
            :statusBar="statusBar"
            :sideBar="sideBar"
            :rowHeight="30"
            :headerHeight="30"
            :floatingFiltersHeight="35"
            :checkboxSelection="true"
            :domLayout="domLayout"
            @column-resized="onColumnResized">
          </ag-grid-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-enterprise';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss';

import EditMISPromo from '@/components/ag-grid-tables/promos/EditMISPromo.vue';

export default {
  name: 'MISDashboardComponent',
  components: {
    AgGridVue,
    EditMISPromo,
  },
  props: {
    filteredData: {
      type: Array,
      default: null,
    },
    activeFilterStatus: {
      type: String
    }
  },
  data() {
    return {
      autoGroupColumnDef: null,
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      domLayout: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filterParams: {
          suppressAndOrCondition: true,
          newRowsAction: 'keep',
        },
      },
      statusBar: null,
      sideBar: null,
      columnDefs: null,
      tableData: null,
      // Cell Renderer Components
      components: {
      },
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
    filteredData(val) {
      if (val !== null) {
        if(this.activeFilterStatus == 'edit-requests') {
          val.forEach((x) => {
            (x.mis['mis_id'] = x.mis_id), (x.mis['id'] = x.id);
            x.mis['start_date'] = x.start_date;
            x.mis['end_date'] = x.end_date;
            x.mis['retail_price'] = x.retail_price;
            x.mis['effective_first'] = x.effective_first;
            x.mis['effective_first_per'] = x.effective_first_per;
            x.mis['effective_multi'] = x.effective_multi;
            x.mis['effective_multi_per'] = x.effective_multi_per;
            x.mis['promo_tag_id'] = x.promo_tag_id;
            x.mis['custom_tag_id'] = x.custom_tag_id;
            x.mis['geo_id'] = x.geo_id;
            x.mis['status'] = x.status;
            x.mis['comments'] = x.comments;
          });

          var tempData = val.map((x) => {
            return x.mis;
          });

          this.tableData = tempData;
        } else {
          this.tableData = val;
        }
      } else {
        this.populateTableData();
      }
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem('userDetails')).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem('userDetails')).id;
    },
    status() {
      // console.log(data && data ? data.status:'');
      return event.node;
    },
    yesText() {
      return 'Yes';
    },
    noText() {
      return 'No';
    },
  },
  methods: {
    setAutoHeight() {
      this.gridApi.setDomLayout('autoHeight');
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector('#autoHeightGrid').style.height = '';
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close('#div-with-loading > .con-vs-loading');
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef['suppressMovable'] = true;
      } else {
        this.defaultColDef['suppressMovable'] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        // this.gridOptions.columnApi.setColumnPinned('domain', null);
      } else {
        // this.gridOptions.columnApi.setColumnPinned('domain', 'left');
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    refreshPage() {
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    refreshPageWithFilters() {
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    populateTableData() {
      if (this.filteredData !== null) {
        this.tableData = this.filteredData;
      }
    },
    viewAllMIS() {
      this.$store.dispatch('setSwitchToTab', 'mis');
      this.$router.push('/promos/lists');
    },
  },
  beforeMount() {
    // Table Data AXIOS Call
    this.populateTableData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: 'Client Name',
        field: 'new_reseller.name',
        filter: 'agSetColumnFilter',
        minWidth: 150
      },
      {
        headerName: 'Type',
        field: 'type',
        filter: 'agTextColumnFilter',
        minWidth: 100,
      },
      {
        headerName: 'TLD',
        field: 'tld.tld_name',
        filter: 'agSetColumnFilter',
        minWidth: 100,
      },
      {
        headerName: 'Start Date',
        field: 'start_date',
        filter: 'agDateColumnFilter',
        minWidth: 150,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split('-');
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      },
      {
        headerName: 'End Date',
        field: 'end_date',
        filter: 'agDateColumnFilter',
        minWidth: 150,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            let dateAsString = cellValue;
            if (dateAsString == null) return -1;
            let dateParts = dateAsString.split('-');
            let cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
      }
    ]),
      // Set Grid sidebar
      (this.sideBar = {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
      });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    //agigrid loader
    this.gridApi.showLoadingOverlay();

    // Resize to fit columns
    this.sizeColumnsToFit();

    //set Auto height
    this.setAutoHeight();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    this.$root.$on('tableRefresh', () => {
      this.refreshPage();
    });
  },
  destroyed() {
    this.$store.dispatch('clearListingCount');
    this.$root.$off('tableRefresh');
  },
  beforeDestroy() {
    if (this.$refs.vsCollapseItem) {
      for (let collapseItem of this.$refs.vsCollapseItem) {
        window.removeEventListener('resize', collapseItem);
      }
    }
  },
};
</script>